import { render } from "./DDNotifications.vue?vue&type=template&id=4be7c632"
import script from "./DDNotifications.vue?vue&type=script&lang=js"
export * from "./DDNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__